import React, { useState } from 'react';

// Project's "Current Direction" — the living, current state of the idea.
export default function CurrentDirection({ item, t, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const save = () => {
    onSave((draft || '').trim());
    setEditing(false);
  };

  return (
    <div className="crs-direction" data-testid="creator-project-direction">
      <p className="crs-section__label">
        <span className="crs-proj__symbol">{'\u25c7'}</span>
        {t.cr_direction || 'Current direction'}
      </p>
      {editing ? (
        <div className="crs-direction__edit">
          <textarea
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            rows={3}
            autoFocus
            placeholder={t.cr_direction_ph || 'Where is this heading?\u2026'}
            data-testid="creator-direction-input"
          />
          <div className="crs-item__addbtns">
            <button type="button" className="crs-btn" onClick={save} data-testid="creator-direction-save">
              {t.cr_save || 'Save'}
            </button>
            <button type="button" className="crs-btn is-quiet" onClick={() => setEditing(false)} data-testid="creator-direction-cancel">
              ×
            </button>
          </div>
        </div>
      ) : item.direction ? (
        <p
          className="crs-direction__text"
          data-testid="creator-direction-text"
          onClick={() => { setDraft(item.direction); setEditing(true); }}
        >{item.direction}</p>
      ) : (
        <button
          type="button"
          className="crs-direction__empty"
          onClick={() => { setDraft(''); setEditing(true); }}
          data-testid="creator-direction-add"
        >{t.cr_direction_empty || 'No direction yet \u2014 capture where this is heading.'}</button>
      )}
    </div>
  );
}
